import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { translate } from '../../../utils/util';
import ListPagination from '../../../components/UI/ListPaginationUl';
import BackButton from '../../../components/UI/BackButton';
import { TitleUI, SubtitleUI } from '../../../components/UI/LabelTitleUI';
import TokenListItem from './TokenListItem';
import * as configAction from '../../../actions/configAction';
import { ENUMS } from '../../../utils/constants';
import ConfigurationService from '../../../services/ConfigurationService';

const TokenList = (props) => {
    const [tokens, setTokens] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        if (props.tokens?.length > 0) {
            if (tokens.length > 0 && currentPage === 0) {
                setTokens(props.tokens);
            } else {
                setTokens((prevState) => ([...prevState, ...props.tokens]));
            }
        } else {
            setTokens([]);
        }
        // eslint-disable-next-line
    }, [props?.tokens]);

    useEffect(() => {
        props.getToken({
            PageSize: ENUMS.ePagination.PageSize.value,
            PageIndex: currentPage
        });
        // eslint-disable-next-line
    }, [currentPage]);

    const onSelectItemChange = (item) => {
        props.setToken(item);
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <SubtitleUI icon="mdi mdi-printer" label={translate('menu.token', 'configuration')} />
                </div>
            </div>
            <div id="TokenList" className="container-fluid">
                <ListPagination
                    page={props.tokens?.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    data={tokens.map((item, index) => {
                        return (
                            <TokenListItem
                                key={`oi-${index}`}
                                route={{ pathname: '../token/detail' }}
                                data={item}
                                onSelectItemChange={onSelectItemChange}
                            />
                        );
                    })}
                />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        tokens: state.configReducer.tokens,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getToken: (filter) => {
            dispatch(ConfigurationService.getToken(filter));
        },
        setToken: (token) => {
            dispatch(configAction.setToken(token));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TokenList));
